module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"binaryLinkTitle":"File was submitted. Click to download."}}')
  delete Component.options._Ctor
}
